import React, { Component } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { selectMyAlertsWrapper } from '../../selectors/PdpNameSpaceSelector';
import MyAlertsSignup from '../MyAlertsSignup/MyAlertsSignup';
import { clearData, myAlertsLoader } from '../../actions/MyAlertsAction';
import * as styles from './MyAlertsTooltip.css';

const cx = classNames.bind(styles);
export class MyAlertTooltip extends Component {
    static defaultProps = {
        closeMyAlert: () => {},
        actions: {},
        myAlerts: {
            isLoader: false,
        },
        isSwatchTooltip: false,
        fromMiniPDP: false,
    };

    static propTypes = {
        closeMyAlert: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.func])),
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        myAlerts: PropTypes.oneOfType([PropTypes.object]),
        isSwatchTooltip: PropTypes.bool,
        fromMiniPDP: PropTypes.bool,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.closeToolTip = this.closeToolTip.bind(this);
        this.tooltipRef = null;
    }

    state = {
        invalidEmail: false,
        fadeOutAnimation: false,
    };

    componentDidMount() {
        this.adjustTooltipPlacement();
    }

    componentWillReceiveProps(nextProps) {
        const { myAlerts } = this.props;
        if (nextProps.myAlerts.isSuccess && myAlerts.isSuccess !== nextProps.myAlerts.isSuccess) {
            setTimeout(() => {
                this.setState({ fadeOutAnimation: true });
                this.closeToolTip();
            }, 3000);
        }
    }

    closeToolTip() {
        this.props.actions.clearData({ sourceMiniPDP: this.props.fromMiniPDP });
        this.props.closeMyAlert();
    }

    // TODO: #TJ migrate to <TippyTooltip />
    /* istanbul ignore next */
    transformPrefix = (element, value) => {
        element.style.msTransform = value; // IE
        element.style.webkitTransform = value; // Chrome and Safari
        element.style.MozTransform = value; // Firefox
        element.style.OTransform = value; // Opera
        element.style.transform = value;
    };

    adjustTooltipPlacement = () => {
        // adjust tooltip placement
        /* istanbul ignore next */
        if (this.tooltipRef) {
            const clientRect = this.tooltipRef.getBoundingClientRect();
            if (!clientRect) return;
            const windowWidth = window.innerWidth;
            const offsetLeft = clientRect.left;
            const offsetRight = windowWidth - offsetLeft;

            if (!this.props.isSwatchTooltip && offsetRight < 316) {
                this.tooltipRef.style.right = 0;
                this.tooltipRef.style.left = 'auto';
            }

            if (this.props.isSwatchTooltip) {
                if (offsetLeft < 10) {
                    this.transformPrefix(
                        this.tooltipRef,
                        `translateX(${10 - offsetLeft}px) translateY(-125%)`
                    );
                    this.transformPrefix(
                        this.tooltipRef.children[2],
                        `translateX(${offsetLeft - 10}px)`
                    );
                }
                if (offsetRight < 316 && windowWidth < 1440) {
                    this.transformPrefix(
                        this.tooltipRef,
                        `translateX(${offsetRight - 316}px) translateY(-125%)`
                    );
                    this.transformPrefix(
                        this.tooltipRef.children[2],
                        `translateX(${316 - offsetRight}px)`
                    );
                }
                if (offsetRight < 316 && windowWidth >= 1440) {
                    this.transformPrefix(
                        this.tooltipRef,
                        `translateX(${offsetRight - 316}px) translateY(13px)`
                    );
                    this.transformPrefix(
                        this.tooltipRef.children[0],
                        `translateX(${316 - offsetRight}px)`
                    );
                    this.transformPrefix(
                        this.tooltipRef.children[2],
                        `translateX(${316 - offsetRight}px)`
                    );
                }
            }
        }
    };

    render() {
        const { fadeOutAnimation } = this.state;
        const { myAlerts, isSwatchTooltip } = this.props;
        return (
            <div className={cx('toolTipContainer', { isSwatchTooltip })}>
                <div
                    ref={(node) => {
                        this.tooltipRef = node;
                    }}
                    className={cx(
                        'toolTipBody',
                        'subContainer',
                        { fadeOut: fadeOutAnimation },
                        { successAlignemnt: myAlerts.isSuccess }
                    )}
                >
                    <div className={cx('toolTipArrow', 'toolTipArrowBefore')} />
                    <MyAlertsSignup
                        onTooltipClose={this.closeToolTip}
                        pdpSignUpErrorMsg
                        fromMiniPDP={this.props.fromMiniPDP}
                    />
                    <div className={cx('toolTipArrow')} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    myAlerts: selectMyAlertsWrapper(ownProps.fromMiniPDP)(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            clearData,
            myAlertsLoader,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyAlertTooltip);
